export const DEVICE_TYPE = {
  sp: "mobile",
  pc: "pc",
};

export const IMG_KV = [
  {
    // layback
    href: "https://www.subaru.jp/levorg/layback/?=sppfa",
    onclick: "aa_clicktrack('sp_pfa006');ga_clicktrack('sp_pfa006');",
    src: "https://cdn.kaizenplatform.net/v2/attachments/000/374/006/3a3ae05dab74fa2d7314a05db891ef259e8f8361.jpg",
    alt: "LEVORG LAYBACK",
  },
  {
    // eyesight
    href: "https://www.subaru.jp/safety/eyesight/?=sppfa",
    onclick: "aa_clicktrack('sp_pfa006');ga_clicktrack('sp_pfa006');",
    src: "https://cdn.kaizenplatform.net/v2/attachments/000/374/054/d5b0018c7385ebb4ae17e9a36fe15c4f64f2abec.png",
    alt: "EYESIGHT",
  },
  {
    // suv present
    href: "https://www.subaru.jp/campaign/suv2023/?=sppfa",
    onclick: "aa_clicktrack('sp_pfa006');ga_clicktrack('sp_pfa006');",
    src: "https://cdn.kaizenplatform.net/v2/attachments/000/374/007/a984026e522348da9dd37ff0aa99eafa3b62b301.png",
    alt: "SUV PRESENT",
  },
  {
    // japan mobility show
    href: "https://www.subaru.jp/jms/?=sppfa",
    onclick: "aa_clicktrack('sp_pfa006');ga_clicktrack('sp_pfa006');",
    src: "https://cdn.kaizenplatform.net/v2/attachments/000/374/178/fb61167fca4b7f07d90fe71cfe2b045011fd2036.png",
    alt: "SUBARU JAPAN MOBILITY SHOW 2023",
  },
];

export const IMG_HISTORY_TITLE =
  "https://cdn.kaizenplatform.net/v2/attachments/000/373/700/d7821e8e3c792d7c42df3075744e24e1af1589c5.svg";

export const CTA_ICON = {
  estimateSim: {
    blue: "https://cdn.kaizenplatform.net/v2/attachments/000/374/347/5a4bf999192f8048ecbaeb79435e2087ee571bba.png",
    white: "https://cdn.kaizenplatform.net/v2/attachments/000/373/628/067af7de875cb18cffaa9e7353a8be0a6a98258a.png",
  },
  searchDealer: {
    blue: "https://cdn.kaizenplatform.net/v2/attachments/000/374/348/be23aa0cacb070853ebf54aeb8f25deec39c65ce.png",
    white: "https://cdn.kaizenplatform.net/v2/attachments/000/373/627/c5255ff47230ad937398cd492c84a1c31513a165.png",
  },
  searchDrivecar: {
    blue: "https://cdn.kaizenplatform.net/v2/attachments/000/374/346/ab3aae97656f9402a086fbf4b9add5bf34a01eba.png",
    white: "https://cdn.kaizenplatform.net/v2/attachments/000/374/549/dcb3e1dd8b91cca6934bfac60e252bcea9eec7f0.png",
  },
  lineup: {
    white: "https://cdn.kaizenplatform.net/v2/attachments/000/375/061/c0d00643d7eb848b90c56ec0ce47c7932881ac34.svg",
  },
};
